import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import * as types from 'constants/actionTypes';

const BranchSelectAutoCompleteInput = ({ name, label, defaultValue, hintText, onChange }) => {
  const dispatch = useDispatch();

  // Getting state from Redux store
  const { userBranches, branchId } = useSelector((state) => state.common) || [];
  const { [name]: reduxValue = "", error: formError = {} } = useSelector((state) => state.form) || {};
  const reduxError = formError[name] || "";

  const [options, setOptions] = useState([]);
  const [localValue, setLocalValue] = useState([]);
  
  useEffect(() => {
    // Define Branch options
    if (userBranches && userBranches.length > 0) {
      const newOptions = userBranches.map((item) => ({
        title: item.name,
        value: item.id.toString(),
      }));
      setOptions(newOptions); // Save new options in state
      if (defaultValue || defaultValue === ""){
        setLocalValue(defaultValue);
        dispatch({ type: types.FORM_INPUT, value: defaultValue, name });
      }else{
        const defaultOption = branchId ? newOptions.find(item => item.value === branchId.toString()) : [];
        setLocalValue(defaultOption);
        dispatch({ type: types.FORM_INPUT, value: defaultOption.value, name });
      }
      // Update default value on Redux (Id only)
      
    }
  }, [userBranches, branchId]);

  const handleChange = (selectedOption) => {
    // Handle Change Value
      setLocalValue(selectedOption)
      if (selectedOption){
        dispatch({ type: types.FORM_INPUT, value: selectedOption.value, name });
        const item = options.find((item) => item.name === selectedOption.value);
        if (item){
          dispatch({ type: types.FORM_INPUT, value: selectedOption, name: `${name}Text` });
        }
      }else{
        dispatch({ type: types.FORM_INPUT, value: "", name });
        dispatch({ type: types.FORM_INPUT, value: null, name: `${name}Text` });
      }

      if (onChange){
        onChange(selectedOption)
      }
  }

  return (
    <div className="form-group BranchSelect">
      <Autocomplete
        freeSolo
        id={name}
        value={localValue}
        options={options}
        getOptionLabel={options => options.title ? options.title : ``}
        InputLabelProps={{ shrink: true }} 
        onChange={(e, selectedOption) => handleChange(selectedOption)}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            variant="standard"
            placeholder={hintText}
          />
        )}
      />
    </div>
  );
}

export default BranchSelectAutoCompleteInput;
